import { DeleteFilled, EditOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Pagination,
  Row,
  Space,
  Switch,
  Table,
  Tooltip,
} from "antd";
import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Heading from "../../../components/common/heading";
import NotFound from "../../../components/common/notFound";
import ConfirmModal from "../../../components/modal/confirmModal";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import { SUCCESS_CODE } from "../../../lib/const";
import { routes } from "../../../routes";
import {
  deleteRoleUser,
  searchRoleManagement,
  updateRoleUserStatus,
} from "../../../services/userManagement";
import Search from "./components/search";
import { SearchRoleContext } from "./searchContext";

const Role = () => {
  const navigate = useNavigate();
  let [no, setNo] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { searchValues, pageValues, setPageValues, fetchData, setFetchData } =
    useContext(SearchRoleContext);
  const [confirmModal, setConfirmModal] = useState({
    type: "",
    show: false,
    id: 0,
  });

  const [dataSource, setDataSource] = useState([]);

  const fetchRoles = useCallback(
    async (searchValues, pageValues) => {
      console.log(searchValues, pageValues);
      setLoading(true);
      const res = await searchRoleManagement(searchValues, pageValues);
      if (res?.data.code === SUCCESS_CODE) {
        const { objectValue, pageValue } = res.data;
        // console.log("objectValue :: ", objectValue);
        // console.log("pageValues :: ", pageValue);
        let _p =
          parseInt(pageValues.page) === 0
            ? parseInt(pageValues.page)
            : parseInt(pageValues.page) * pageValues.pageSize;
        setNo(_p);
        setDataSource(objectValue);
        setPageValues(pageValue);
        setLoading(false);
      } else {
        console.log("err ::: ", res?.data?.message);
        setDataSource([]);
        setLoading(false);
      }
    },
    [setDataSource]
  );

  useEffect(() => {
    if (fetchData) {
      fetchRoles(searchValues, pageValues);
      setFetchData(false);
    }
  }, [fetchRoles, fetchData]);

  const onChangeStatus = async () => {
    // const request = {
    //   roleId: confirmModal?.id,
    //   recStatus: confirmModal?.status ? false : true,
    // };

    const request = {
      requestObject: {
        roleId: confirmModal?.id,
        recStatus: confirmModal?.status ? false : true,
      },
    };

    const res = await updateRoleUserStatus(request);
    if (res?.data?.code === SUCCESS_CODE) {
      setFetchData(true);
      setSuccessModal(true);
    } else {
      setFailModal(true);
    }

    setTimeout(() => {
      setFailModal(false);
      setSuccessModal(false);
    }, 1000);
    setConfirmModal({
      type: "",
      show: false,
      id: 0,
    });
  };

  const columns = [
    {
      width: 100,
      align: "center",
      title: "ลำดับ",
      dataIndex: "no",
      key: "no",
      render: (_, record) => <span>{(no += 1)}</span>,
    },
    {
      title: "ชื่อ role",
      dataIndex: "roleNameTh",
      key: "roleNameTh",
      sorter: (a, b) => a.roleNameTh - b.roleNameTh,
    },
    {
      title: "รายละเอียด Role",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description - b.description,
      render: (_, record) => <span>{record.description || "-"}</span>,
    },
    {
      title: "Permission",
      dataIndex: "permissionTh",
      key: "dataId",
      sorter: (a, b) => a.dataId - b.dataId,
    },
    {
      title: "สถานะ Role",
      dataIndex: "roleStatus",
      key: "recStatus",
      width: 140,
      sorter: (a, b) => a.recStatus - b.recStatus,
      render: (_, record) => (
        <>
          <Switch
            checked={record.roleStatus}
            onChange={() =>
              setConfirmModal({
                type: "change_status",
                show: true,
                id: record.roleId,
                status: record.roleStatus,
              })
            }
          />
        </>
      ),
    },
    {
      title: "การจัดการ",
      dataIndex: "id",
      key: "id",
      width: 140,
      render: (_, record) => (
        <>
          <Space>
            <Tooltip
              title="แก้ไข"
              color={"#31343A"}
              key={"edit"}
              placement="bottom"
            >
              <Button
                shape="circle"
                style={{ backgroundColor: "#FEF1DF", border: "none" }}
                onClick={() =>
                  navigate(
                    routes.view_user_role_management + "/" + record.roleId
                  )
                }
              >
                <EditOutlined style={{ color: "#F79009" }} />
              </Button>
            </Tooltip>
            <Tooltip
              title="ลบ"
              color={"#31343A"}
              key={"delete"}
              placement="bottom"
            >
              <Button
                shape="circle"
                style={{ backgroundColor: "#FDE7E5", border: "none" }}
                // onClick={() => setOpenModal(true)}
                onClick={() => {
                  setConfirmModal({
                    type: "delete",
                    show: true,
                    id: record.roleId,
                  });
                }}
              >
                <DeleteFilled style={{ color: "#F04438" }} />
              </Button>
            </Tooltip>
          </Space>
        </>
      ),
    },
  ];

  const onPageChange = (page, pageSize) => {
    setLoading(true);
    setPageValues((prev) => ({
      ...prev,
      page: page - 1,
      pageSize: pageSize,
    }));
    setFetchData(true);
  };

  const onSorter = (pagination, filters, sorter) => {
    setFetchData(true);
    setPageValues((prev) => ({
      ...prev,
      sortBy: sorter && sorter.order ? sorter.columnKey : "roleNameTh",
      sortDirection:
        sorter && sorter.order
          ? sorter.order === "ascend"
            ? "ASC"
            : "DESC"
          : "ASC",
    }));
  };

  const handleDeleteUser = async () => {
    const res = await deleteRoleUser(confirmModal.id);
    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setFetchData(true);
    } else {
      setFailModal(true);
    }

    setTimeout(() => {
      setFailModal(false);
      setSuccessModal(false);
    }, 2000);
    setConfirmModal({
      type: "",
      show: false,
      id: 0,
    });
  };

  return (
    <div className="role_management">
      <div className="flex justify-between items-center">
        <Heading text={"การจัดการบทบาทและสิทธิ์การเข้าถึง"} size={4} />
        <div>
          <Button
            type="primary"
            onClick={() => navigate(routes.add_user_role_management)}
          >
            <PlusOutlined /> เพิ่มสิทธิ์
          </Button>
        </div>
      </div>

      <Search />

      <Row gutter={[24, 12]} style={{ marginTop: 20, marginBottom: 80 }}>
        <Col span={24}>
          รายการทั้งหมด{" "}
          <span className="pr-purple" style={{ fontWeight: 600 }}>
            {pageValues?.total}
          </span>{" "}
          รายการ
        </Col>
        <Col span={24}>
          <Table
            rowKey={"key"}
            dataSource={dataSource}
            columns={columns}
            locale={{ emptyText: <NotFound /> }}
            loading={loading}
            pagination={false}
            onChange={onSorter}
            // scroll={{
            //   x: 1300,
            // }}
          />
        </Col>
        <Col span={24} align="right">
          <Pagination
            showSizeChanger
            defaultCurrent={pageValues.page + 1 || 1}
            total={pageValues.total || 10}
            onChange={onPageChange}
            showTotal={(total) => `รวม ${total} รายการ`}
          />
        </Col>
      </Row>

      <ConfirmModal
        actionType={""}
        title={"ยืนยันการเปลี่ยนสถานะ"}
        modalText={`คุณต้องการเปลี่ยนสถานะเป็น “${
          confirmModal?.status ? "ระงับ" : "เปิด"
        }การใช้งาน” ใช่ไหม ?`}
        open={confirmModal.type === "change_status" ? confirmModal.show : false}
        onOk={() => {
          onChangeStatus();
        }}
        onCancel={() => {
          setConfirmModal({
            type: "",
            show: false,
            id: 0,
          });
        }}
      />

      <ConfirmModal
        actionType={"delete"}
        title={"ยืนยันการลบข้อมูล"}
        modalText={"คุณต้องการลบข้อมูล ?"}
        open={confirmModal.type === "delete" ? confirmModal.show : false}
        onOk={() => {
          handleDeleteUser();
        }}
        onCancel={() => {
          setConfirmModal({
            type: "",
            show: false,
            id: 0,
          });
        }}
      />
      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
    </div>
  );
};

export default Role;
